<template>
  <div class="d-flex">
    <div class="select-wrapper">
      <eewc-select-box
        :placeholder="t('Site')"
        class="mr-2"
        :value="currentLocation"
        :items="locations.locations.map(location=> ({text: location.name, value: location.id, ...location}))"
        :is-attached="true"
        item-slot
        @input="locations.setCurrentLocationAndFloorplan"
      >
        <template #item="{ item }">
          <tooltipped-text :text="item.text"/>
        </template>
      </eewc-select-box>
    </div>
    <div class="select-wrapper">
      <eewc-select-box
        v-if="locations.currentLocation"
        :items="floors.floors.map(floor=> ({text: floor.name, value: floor.id, ...floor}))"
        :placeholder="t('Floor')"
        :value="currentFloor"
        :disabled="!floors.floors.length"
        :is-attached="true"
        item-slot
        @input="floors.setCurrentFloor"
      >
        <template #item="{ item }">
          <tooltipped-text :text="item.text"/>
        </template>
      </eewc-select-box>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useFloorsStore, useLocationsStore } from '@/stores'
import { computed } from 'vue'
import { t } from '@/plugins/i18n';
import TooltippedText from "@eencloud/eewc-components/src/components/tooltip/TooltippedText/TooltippedText.vue";

const floors = useFloorsStore()
const locations = useLocationsStore()

// Select buttons
const currentLocation = computed(() => {
  return {
    text: locations?.currentLocation?.name,
    value: locations?.currentLocation?.id,
    ...locations?.currentLocation
  }
})

const currentFloor = computed(() => {
  return {
    text: floors?.currentFloor?.name,
    value: floors?.currentFloor?.id,
    ...floors?.currentFloor
  }
})
</script>
<style lang="scss">
@import "../../styles/public/main.scss";

html, body {
  overflow: hidden;
}

.select-wrapper {
  max-width: 232px
}

</style>
